import React from 'react'
import cn from 'classnames'

import { ReactComponent as LockIcon } from '../../assets/icons/lock.svg'
import { ReactComponent as ChevronIcon } from '../../assets/icons/tabs/chevron-left.svg'

import styles from './EventPill.module.scss'

const EventPill = ({ name, locked, disabled, startTimeDisplay, onChange }) => {
  const classNames = cn(styles.eventPill, { [styles.locked]: locked, [styles.disabled]: disabled })
  let handleOnChange = onChange
  let icon = <ChevronIcon className={styles.chevron} />

  if (locked) {
    handleOnChange = null
    icon = <LockIcon className={styles.lock} />
  }

  return (
    <li className={classNames} onClick={handleOnChange}>
      <span className={styles.nameAndDate}>
        <span className={styles.name}>{name}</span>
        <span className={styles.date}>{startTimeDisplay}</span>
      </span>
      {icon}
    </li>
  )
}

export default EventPill
